import { environment } from '@env';
import { useApiFetch } from './useApiFetch';

export const useApiServiceModels = () => {
  const fetchData = useApiFetch();

  const getAssemblies = async () => {
    const url = `${environment.BASE_URL}v1/dgs/train/models/assemblies`;
    return fetchData(url);
  };

  const getDryGasSealTags = async datasource_id => {
    const url = `${environment.BASE_URL}v1/dgs/train/models/assemblies/${datasource_id}/dgs_tags`;
    return fetchData(url);
  };

  const getCount = async (datasourceId, tagAliasName) => {
    let tagAliasNameString;
    if (Array.isArray(tagAliasName)) {
      tagAliasNameString = `[${tagAliasName.map(value => `'${value}'`).join(', ')}]`;
    } else {
      tagAliasNameString = tagAliasName;
    }

    const url = `${environment.BASE_URL}v1/dgs/train/models/count?datasource_id=${datasourceId}&tag_alias_name=${tagAliasNameString}`;
    return fetchData(url);
  };

  const getModelsData = async (datasourceId, tagAliasName) => {
    const url = `${environment.BASE_URL}v1/dgs/train/models`;

    let formattedTagAliasName;
    if (typeof tagAliasName === 'string' && tagAliasName.startsWith('[') && tagAliasName.endsWith(']')) {
      formattedTagAliasName = [tagAliasName];
    } else if (Array.isArray(tagAliasName)) {
      const tagString = `[${tagAliasName.map(tag => `'${tag}'`).join(', ')}]`;
      formattedTagAliasName = [tagString];
    } else {
      formattedTagAliasName = [`['${tagAliasName}']`];
    }

    const requestBody = {
      datasource_id: datasourceId,
      tag_alias_name: formattedTagAliasName
    };
    return fetchData(url, 'POST', requestBody);
  };

  const updateModelStatus = async (modelName, status) => {
    const url = `${environment.BASE_URL}v1/dgs/train/status-update`;
    return fetchData(url, 'PUT', { MODEL_NAME: modelName, STATUS: status });
  };

  const deleteModel = async modelName => {
    const url = `${environment.BASE_URL}v1/dgs/train/model/delete?model_id=${modelName}`;
    return fetchData(url, 'GET');
  };

  return {
    getAssemblies,
    getDryGasSealTags,
    getCount,
    getModelsData,
    updateModelStatus,
    deleteModel
  };
};
